import React from 'react';
import { Link } from 'react-router-dom';
import { MailIcon, PhoneIcon, MapPinIcon, FacebookIcon, InstagramIcon } from 'lucide-react';
import { getContent } from '../config/content';
import { theme } from '../config/theme';

const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer style={{ backgroundColor: theme.colors.primary[900], color: theme.colors.text.inverse }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">{getContent('company.name')}</h3>
            <p className="text-sm mb-4" style={{ color: theme.colors.primary[200] }}>
              {getContent('company.tagline')}
            </p>
            <div className="flex space-x-4">
              <a 
                href="#" 
                className="transition-opacity hover:opacity-80"
                style={{ color: theme.colors.primary[100] }}
                aria-label="Facebook"
              >
                <FacebookIcon className="h-5 w-5" />
              </a>
              <a 
                href="#" 
                className="transition-opacity hover:opacity-80"
                style={{ color: theme.colors.primary[100] }}
                aria-label="Instagram"
              >
                <InstagramIcon className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link 
                  to="/home" 
                  className="text-sm transition-colors hover:underline"
                  style={{ color: theme.colors.primary[200] }}
                >
                  {getContent('navigation.links.home')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/rentals" 
                  className="text-sm transition-colors hover:underline"
                  style={{ color: theme.colors.primary[200] }}
                >
                  {getContent('navigation.links.rentals')}
                </Link>
              </li>
              <li>
                <Link 
                  to="/contact" 
                  className="text-sm transition-colors hover:underline"
                  style={{ color: theme.colors.primary[200] }}
                >
                  {getContent('navigation.links.contact')}
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-2">
                <PhoneIcon className="h-4 w-4 mt-1" style={{ color: theme.colors.primary[300] }} />
                <span className="text-sm" style={{ color: theme.colors.primary[200] }}>
                  {getContent('company.contact.phone')}
                </span>
              </li>
              <li className="flex items-start space-x-2">
                <MailIcon className="h-4 w-4 mt-1" style={{ color: theme.colors.primary[300] }} />
                <span className="text-sm" style={{ color: theme.colors.primary[200] }}>
                  {getContent('company.contact.email')}
                </span>
              </li>
              <li className="flex items-start space-x-2">
                <MapPinIcon className="h-4 w-4 mt-1" style={{ color: theme.colors.primary[300] }} />
                <span className="text-sm" style={{ color: theme.colors.primary[200] }}>
                  {getContent('company.contact.serviceArea')}
                </span>
              </li>
            </ul>
          </div>

          {/* Business Hours */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Business Hours</h3>
            <ul className="space-y-2 text-sm" style={{ color: theme.colors.primary[200] }}>
              <li>{getContent('company.businessHours.weekdays')}</li>
              <li>{getContent('company.businessHours.saturday')}</li>
              <li>{getContent('company.businessHours.sunday')}</li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="mt-8 pt-8 border-t" style={{ borderColor: theme.colors.primary[700] }}>
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-sm" style={{ color: theme.colors.primary[300] }}>
              © {currentYear} {getContent('company.name')}. All rights reserved.
            </p>
            <div className="flex space-x-6 mt-4 md:mt-0">
              <Link 
                to="/privacy" 
                className="text-sm transition-colors hover:underline"
                style={{ color: theme.colors.primary[300] }}
              >
                Privacy Policy
              </Link>
              <Link 
                to="/terms" 
                className="text-sm transition-colors hover:underline"
                style={{ color: theme.colors.primary[300] }}
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
